import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../redux/hooks'

interface ProtectedRouteProps {
  requireAdmin?: boolean
  children?: React.ReactNode
}

export default function ProtectedRoute({
  requireAdmin = false,
  children
}: ProtectedRouteProps) {
  const user = useAppSelector((state) => state.user)
  const isDevelopment =
    import.meta.env.DEV || import.meta.env.VITE_RUN_ENV === 'local'

  // Bypass auth in development
  if (isDevelopment) {
    console.log('Development mode: bypassing authentication for admin routes')
    return children ? <>{children}</> : <Outlet />
  }

  const isAuthenticated = Boolean(
    user.token && user.tokenExpiry && new Date(user.tokenExpiry) > new Date()
  )
  const isAdmin =
    user.roles?.some(
      (role) => (role as { name?: string }).name?.toLowerCase() === 'admin'
    ) || false

  console.log('ProtectedRoute auth check:', {
    hasToken: !!user.token,
    tokenExpiry: user.tokenExpiry,
    tokenValid: user.tokenExpiry
      ? new Date(user.tokenExpiry) > new Date()
      : false,
    isAuthenticated,
    roles: user.roles,
    isAdmin,
    requireAdmin
  })

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login')
    return <Navigate to="/admin/login" replace />
  }

  if (requireAdmin && !isAdmin) {
    console.log('Not admin, redirecting to home')
    return <Navigate to="/" replace />
  }

  return children ? <>{children}</> : <Outlet />
}
